import type { LiveOrderBy } from '@module/apis/client-side/live/type';

type SearchParamsLike = Pick<URLSearchParams, 'get'>;

export type LiveSortType = 'newbj' | 'hot' | 'new' | 'viewcount';

interface ResolvedLiveSort {
  onlyNewBj: 'Y' | 'N';
  orderBy: LiveOrderBy;
  sortType: LiveSortType;
}

const LIVE_SORT_BY_TYPE: Record<LiveSortType, Pick<ResolvedLiveSort, 'onlyNewBj' | 'orderBy'>> = {
  newbj: { onlyNewBj: 'Y', orderBy: 'user' },
  hot: { onlyNewBj: 'N', orderBy: 'hot' },
  new: { onlyNewBj: 'N', orderBy: 'new' },
  viewcount: { onlyNewBj: 'N', orderBy: 'user' },
};

export function getLiveSortByType(sortType: LiveSortType): ResolvedLiveSort {
  return {
    ...LIVE_SORT_BY_TYPE[sortType],
    sortType,
  };
}

export function getDefaultLiveSortType(defaultOrderBy: LiveOrderBy = 'user'): LiveSortType {
  if (defaultOrderBy === 'hot') return 'hot';
  if (defaultOrderBy === 'new') return 'new';
  return 'viewcount';
}

export function getResolvedLiveSort(
  searchParams: SearchParamsLike,
  defaultOrderBy: LiveOrderBy = 'user',
): ResolvedLiveSort {
  const onlyNewBj = searchParams.get('onlyNewBj') === 'Y' ? 'Y' : 'N';
  const orderByParam = searchParams.get('orderBy');
  const orderBy: LiveOrderBy =
    orderByParam === 'hot' || orderByParam === 'new' || orderByParam === 'user' ? orderByParam : defaultOrderBy;

  if (onlyNewBj === 'Y' && orderBy === 'user') {
    return getLiveSortByType('newbj');
  }

  if (onlyNewBj === 'N' && orderBy === 'hot') {
    return getLiveSortByType('hot');
  }

  if (onlyNewBj === 'N' && orderBy === 'new') {
    return getLiveSortByType('new');
  }

  return getLiveSortByType(getDefaultLiveSortType(orderBy));
}
